// extracted by mini-css-extract-plugin
export default {"body-1":"_WwfTXmYdvYeSOG0ihrk","body-2":"IjNa4DPM_vRy2EvNwsI4","body-3":"PCjEqj8uzDPrwi9AQjoP","ant-typography":"nTGdobf7ZNe8Ipsd0jdY","exportButton":"ZtPYKAu9AKv5iQruZrzX"};